import React, { useEffect, useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import { useChat } from '../hooks/useChat';
import { ChatWindow } from './ChatWindow';
import '../styles/chat.css';

export function ChatWidget({ onOpenChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const {
    messages,
    isLoading,
    sendMessage,
    clearHistory,
    addTicketConfirmation,
  } = useChat();

  useEffect(() => {
    onOpenChange?.(isOpen);
  }, [isOpen, onOpenChange]);

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev);
    setIsFullScreen(false);
    setHasInteracted(true);
  };

  const handleToggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsFullScreen(false);
  };

  return (
    <div
      className={`chat-widget-container ${isOpen ? 'is-open' : ''} ${
        isFullScreen ? 'is-fullscreen is-extended' : ''
      }`}
    >
      {isOpen && (
        <ChatWindow
          messages={messages}
          isLoading={isLoading}
          onSendMessage={sendMessage}
          onClearHistory={clearHistory}
          onClose={handleClose}
          isFullScreen={isFullScreen}
          onToggleFullScreen={handleToggleFullScreen}
          onTicketCreated={addTicketConfirmation}
        />
      )}

      {/* Floating launcher button */}
      <button
        onClick={handleToggleOpen}
        className="chat-launcher-btn"
        aria-label={isOpen ? 'Close chat' : 'Open customer support chat'}
        title="Chat with Sagveek Support"
      >
        {isOpen ? <X size={26} /> : <MessageSquare size={26} />}
        {!isOpen && !hasInteracted && (
          <span className="launcher-badge" aria-label="1 unread message">1</span>
        )}
      </button>
    </div>
  );
}
